import createGetFormInitialValues from './selectors/getFormInitialValues';
import plain from './structure/plain';

export default createGetFormInitialValues(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormInitialValues.js
// module id = 1558
// module chunks = 0